export enum StyleguideScope {
  Global = 'Global',
  Organization = 'Organization',
}

export enum CSSNodeTypes {
  Root = 'root',
  Rule = 'rule',
  Atrule = 'atrule',
  Decl = 'decl',
  Any = 'any',
}

type ClassNameMap = {
  childClassNames?: Record<string, string>;

  // Ideally we should just create a unique classname (via a hash?)
  // But for now, we will just map the components props into a classname
  variants?: Record<string, (props: any) => string>;
};

export const stylguideClassNameMap: Record<string, ClassNameMap> = {
  button: {
    childClassNames: {
      icon: 'button-icon',
    },
    variants: {
      color: (value) => `color-${value}`,
      outline: (value) => `outline-${value}`,
    },
  },
  badge: {
    variants: {
      color: (value) => `color-${value}`,
      outline: (value) => `outline-${value}`,
    },
  },
  typography: {
    variants: {
      typography: (value) => `typography-${value}`,
    },
  },
  card: {
    variants: {
      variant: (value) => `card-${value}`,
    },
  },
  checklist: {
    childClassNames: {
      item: 'item',
      checkbox: 'checkbox',
      checkboxUnchecked: 'checkbox-unchecked',
      checkboxChecked: 'checkbox-checked',
      progressBarContainer: 'progress-bar-container',
      progressBar: 'progress-bar',
      groupTitle: 'group-title',
    },
    variants: {
      variant: (value) => `checklist-${value}`,
    },
  },
  form: {
    childClassNames: {
      formErrorMessage: 'form-error-message',
      formLabel: 'form-label',
      inputField: 'input-field',
      checkbox: 'checkbox',
      checkboxDiv: 'checkbox-div',
      msCard: 'ms-card',
      msCardCheckboxDiv: 'ms-card-checkbox-div',
      ssCard: 'ss-card',
    },
    variants: {
      variant: (value) => `form-${value}`,
    },
  },
  modalV2: {
    childClassNames: {
      backdrop: 'backdrop',
      container: 'container',
    },
    variants: {
      variant: (value) => `modalV2-${value}`,
    },
  },
};
